export default __webpack_public_path__ + "static/iam_role_05-ce18f8f859c7bf79b4da4ccf1c964158.png";